import { render, staticRenderFns } from "./交易项目详情_阶梯竞价版本_无socket.vue?vue&type=template&id=d04f8cf6&scoped=true"
import script from "./交易项目详情_阶梯竞价版本_无socket.vue?vue&type=script&lang=js"
export * from "./交易项目详情_阶梯竞价版本_无socket.vue?vue&type=script&lang=js"
import style0 from "./交易项目详情_阶梯竞价版本_无socket.vue?vue&type=style&index=0&id=d04f8cf6&prod&lang=css"
import style1 from "./交易项目详情_阶梯竞价版本_无socket.vue?vue&type=style&index=1&id=d04f8cf6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d04f8cf6",
  null
  
)

export default component.exports